<template>
  <div :style="style.outer">
    <div :style="style.inner">
      <div :style="style.container.header.outer">
        <div :style="style.container.header.image">
          <ImagePrimary
            :asset="asset"
            :style="style.image"
          />
        </div>
        <div :style="style.container.header.text">
          <HeaderPrimary size="XL" :style="style.header">
            404
          </HeaderPrimary>
          <HeaderPrimary size="LG">
            {{ t('errors.notFound.header') }}
          </HeaderPrimary>
        </div>
      </div>
      <TextPrimary>
        {{ t('errors.notFound.body') }}
      </TextPrimary>
      <div :style="style.container.footer">
        <LinkPrimary :to="toDashboard">
          {{ t('errors.notFound.backToDashboard') }}
        </LinkPrimary>
        <LinkPrimary :href="hrefContact">
          {{ t('errors.notFound.contactSupport') }}
        </LinkPrimary>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useStyle } from '@composables/use-style';
import { CONTACTS } from '@constants';
import { ENTRY_POINTS } from '@constants/entry-points';
import { IMAGE_FILES } from '@constants/ui-constants';
import HeaderPrimary from '@v1/components/header/HeaderPrimary.vue';
import ImagePrimary from '@v1/components/image/ImagePrimary.vue';
import LinkPrimary from '@v1/components/link/LinkPrimary.vue';
import TextPrimary from '@v1/components/text/TextPrimary.vue';

const { t } = useI18n();

const { spacing } = useStyle();

const style = ref({
  container: {
    footer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing.MD,
      justifyContent: 'space-between',
      width: '100%',
    },
    header: {
      image: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
      },
      outer: {
        display: 'flex',
        gap: spacing.MD,
        width: '100%',
      },
      text: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: spacing.SM,
        justifyContent: 'center',
        width: 'clamp(fit-content, 100%, 100%)',
      },
    },
  },
  header: {
    fontSize: spacing.XXXL,
  },
  image: {
    maxWidth: '240px',
    minWidth: '240px',
    width: '100%',
  },
  inner: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.XL,
    height: '100%',
    justifyContent: 'center',
    maxWidth: '480px',
    width: '100%',
  },
  link: {
    width: 'fit-content',
  },
  outer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.MD,
    height: '100%',
    justifyContent: 'center',
    minHeight: '100vh',
    minWidth: '272px',
    padding: spacing.LG,
    width: '100%',
  },
});

const asset = ref(IMAGE_FILES.PLACEHOLDER.GENERAL);

const toDashboard = ref(ENTRY_POINTS.PATH.TENANT_HOME());
const hrefContact = ref(`mailto: ${CONTACTS.SUPPORT}`);
</script>
